import { useScrollLock } from "@/hooks/useScrollLock";
import { cn } from "@/lib/utils";
import { Subscription, shouldShowAdsSelector } from "@/redux/user/userSlice";
import { BREAKPOINTS } from "@/settings";
import clsx from "clsx";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useMediaQuery } from "usehooks-ts";

import { Drawer } from "./components/Drawer";
import {
  navigationBurgerMenuIcon,
  navigationEvolutionsIcon,
  navigationHomeIcon,
  navigationPlayersIcon,
  navigationSquadBuilderIcon,
  navigationTacticsIcon,
} from "./components/NavIcons";
import { NavLinkTouchDevice } from "./components/NavLinkTouchDevice";

export const NavBarTouchDevice = ({
  currentRoute,
  userIsLoggedIn,
  canUseClubImport,
  freeUser,
  paidUserButNotUltimate,
  userSubscription,
  handleClick,
}: {
  currentRoute: string;
  userIsLoggedIn: boolean;
  canUseClubImport: boolean;
  freeUser: boolean;
  paidUserButNotUltimate: boolean;
  userSubscription: Subscription;
  handleClick: ({ isPaywalled }: { isPaywalled: boolean }) => void;
}) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const showingAds = useSelector(shouldShowAdsSelector);
  useScrollLock(isDrawerOpen);
  const isMediumMobile = useMediaQuery(BREAKPOINTS.MEDIUM_MOBILE.query);

  return (
    <>
      <nav
        className={cn(
          "fixed bottom-0 left-0 right-0 bg-panel-base border-t border-t-panel-foreground z-22 flex flex-row justify-around  items-start px-3",
          showingAds ? "h-26.5 justify-start" : "h-14.5",
        )}
      >
        <NavLinkTouchDevice
          to="/"
          currentRoute={currentRoute}
          onClick={() => setIsDrawerOpen(false)}
        >
          {navigationHomeIcon}
        </NavLinkTouchDevice>
        <NavLinkTouchDevice
          to="/players"
          currentRoute={currentRoute}
          onClick={() => setIsDrawerOpen(false)}
        >
          {navigationPlayersIcon}
        </NavLinkTouchDevice>
        <NavLinkTouchDevice
          to="/evolutions"
          currentRoute={currentRoute}
          onClick={() => setIsDrawerOpen(false)}
        >
          {navigationEvolutionsIcon}
        </NavLinkTouchDevice>
        <NavLinkTouchDevice
          to="/squad-builder"
          currentRoute={currentRoute}
          onClick={() => setIsDrawerOpen(false)}
        >
          {navigationSquadBuilderIcon}
        </NavLinkTouchDevice>
        {!isMediumMobile && (
          <NavLinkTouchDevice
            to="/tactics"
            currentRoute={currentRoute}
            onClick={() => setIsDrawerOpen(false)}
          >
            {navigationTacticsIcon}
          </NavLinkTouchDevice>
        )}
        <button
          className="flex items-center justify-center w-full h-12.5"
          onClick={(e) => {
            e.stopPropagation();
            setIsDrawerOpen((prev) => !prev);
          }}
        >
          <span className="text-new-gray-450">{navigationBurgerMenuIcon}</span>
        </button>
      </nav>
      <Drawer
        isDrawerOpen={isDrawerOpen}
        currentRoute={currentRoute}
        setIsDrawerOpen={setIsDrawerOpen}
        userIsLoggedIn={userIsLoggedIn}
        freeUser={freeUser}
        paidUserButNotUltimate={paidUserButNotUltimate}
        canUseClubImport={canUseClubImport}
        userSubscription={userSubscription}
        handleClick={handleClick}
        needsExtraPadding={showingAds}
      />
    </>
  );
};
